export default "__VITE_ASSET__0a1f83ce__"